import React from 'react'
import { ArrowUp } from 'lucide-react'
import { useTranslation } from '../../hooks/useTranslation'
import NewsletterForm from './NewsletterForm'
import SocialIcons from './SocialIcons'

const Footer: React.FC = () => {
  const { t, isRTL } = useTranslation()

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <footer className="relative mt-20 border-t border-border bg-surface text-text-2 transition-colors duration-200">
      {/* زر التمرير للناف بار (Scroll to Top Button) */}
      <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 z-10">
        <button
          onClick={scrollToTop}
          className="p-2.5 rounded-full bg-surface-2 border border-border text-gold hover:text-cyan hover:border-gold hover:shadow-[0_0_15px_rgba(212,175,55,0.2)] transition-all duration-200 group"
          aria-label={t('footer.backToTop')}
          title={t('footer.backToTop')}
        >
          <ArrowUp
            size={18}
            className="transform group-hover:-translate-y-0.5 transition-transform duration-150"
          />
        </button>
      </div>

      <div className="container mx-auto px-4 lg:px-8 py-12 text-sm">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 lg:gap-12">
          {/* الهوية والتعريف */}
          <div>
            <h3 className="text-text font-bold text-lg mb-3 tracking-wide flex items-center gap-1">
              BadanIbex<span className="text-xs text-gold font-normal"></span>
            </h3>
            <p className="text-text-muted leading-relaxed mb-4">{t('footer.brand')}</p>
            <div className="border-t border-border/50 pt-4">
              <SocialIcons />
            </div>
          </div>

          {/* الروابط السريعة */}
          <div>
            <h4 className="text-text font-semibold mb-4 text-base">{t('footer.links.title')}</h4>
            <ul className="space-y-2.5">
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/#hero">
                  {t('footer.links.home')}
                </a>
              </li>
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/catalog">
                  {t('footer.links.catalog')}
                </a>
              </li>
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/contact">
                  {t('footer.links.contact')}
                </a>
              </li>
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/about">
                  {t('footer.links.about')}
                </a>
              </li>
            </ul>
          </div>

          {/* الدعم والخصوصية */}
          <div>
            <h4 className="text-text font-semibold mb-4 text-base">{t('footer.support.title')}</h4>
            <ul className="space-y-2.5">
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/faq">
                  {t('footer.support.faq')}
                </a>
              </li>
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/privacy">
                  {t('footer.support.privacy')}
                </a>
              </li>
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/terms">
                  {t('footer.support.terms')}
                </a>
              </li>
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/cookies">
                  {t('footer.support.cookies')}
                </a>
              </li>
              <li>
                <a className="hover:text-gold transition-colors duration-150" href="/sitemap">
                  {t('footer.support.sitemap')}
                </a>
              </li>
            </ul>
          </div>

          {/* النشرة البريدية */}
          <div>
            <h4 className="text-text font-semibold mb-4 text-base">
              {t('footer.newsletter.title')}
            </h4>
            <NewsletterForm />
          </div>
        </div>

        {/* حقوق النشر والفوتر السفلي */}
        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-text-2">
          <span className="font-medium text-text-2">
            © {new Date().getFullYear()}{' '}
            <strong className="text-gold font-bold">BadanIbex BY Fahd Ali</strong>. {t('footer.copyright')}.
          </span>
          <div className="flex items-center gap-2 bg-surface-soft/80 px-3 py-1 rounded-full border border-border/60">
            <span className="w-2 h-2 rounded-full bg-gold shadow-[0_0_8px_rgba(212,175,55,0.8)] animate-pulse inline-block" />
            <span className="text-text font-medium tracking-wide">Tech Charcoal Profile</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
